module.exports = __webpack_public_path__ + "static/img/12.5c7b32de.png";